import React, { useContext, useState } from "react";
import { Alert, Spin, Tabs } from "antd";
import MapPropsContext from "../MapPropsContext";
import Axios from "axios";
import useDebounce from "../../../utils/hooks/useDebounce";
import { getApiHost } from "../../../utils";
import ChartPane from "./ChartPane";
import {
  dataSettingByDensity,
  dataSettingByNumber,
  dataSettingByShare,
  setChartLayoutforDensity,
  setChartLayoutforNumber,
  setChartLayoutforShare,
} from "./RMateChartFusionResourceUtils";
import useRMateChart from "./useRMateChart";

function RMateChartFusionResource({ disabled }) {
  const { chartAjaxParams } = useContext(MapPropsContext);

  const { sidoCode, gubun_code, searchYear, chkRadSvcString, prm_check2, prm_check2_label, prm_check } =
    chartAjaxParams;

  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [prevParams, setPrevParams] = useState();
  const [parsedObject, setParsedObject] = useState({});
  const [_admin, _setAdim] = useState("N");

  useDebounce(
    () => {
      if (isInit) {
        const url = getApiHost() + "/rwdinfolabstats/getRdwAnalsStatsData1.json";

        const newParams = {
          sidoCode,
          gubun_code,
          searchYear,
          chkRadSvcString,
        };

        if (JSON.stringify(prevParams) !== JSON.stringify(newParams)) {
          setPrevParams(newParams);
          setIsLoading(true);
          setParsedObject({}); // 초기화

          Axios.get(url, { params: newParams })
            .then(({ data }) => {
              const _admin = data["adminYn"];
              _setAdim(_admin);
              const dataList = data["item"];
              const { chartShareData1, chartShareData2, chartShareTitle } = dataSettingByShare(
                dataList,
                _admin,
                gubun_code,
                prm_check,
                prm_check2
              );
              const { chartNumberData1, chartNumberData2, chartNumberTitle } = dataSettingByNumber(
                dataList,
                _admin,
                gubun_code
              );
              const { chartDensityData1, chartDensityData2, chartDensityTitle } = dataSettingByDensity(
                dataList,
                _admin,
                gubun_code,
                prm_check2
              );
              // chartBaseData 반환

              setParsedObject({
                chartShareData1,
                chartShareData2,
                chartShareTitle,
                chartNumberData1,
                chartNumberData2,
                chartNumberTitle,
                chartDensityData1,
                chartDensityData2,
                chartDensityTitle,
              });
            })
            .catch((e) => console.error(e))
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    },
    1000,
    [isInit, prevParams, chartAjaxParams, setIsLoading]
  );

  const {
    chartShareData1,
    chartShareTitle, //chartShareData2,
    chartNumberData1,
    chartNumberTitle, //chartNumberData2,
    chartDensityData1,
    chartDensityTitle, //chartDensityData2,
  } = parsedObject;

  return useRMateChart({
    init: () => setIsInit(true),
    style: { minHeight: "540px" },
    disabled,
    children: (
      <div style={{ position: "relative", height: "100%", width: "100%" }}>
        {isLoading && (
          <div
            style={{ position: "absolute", top: 55, zIndex: 1, height: "90%", width: "100%", backgroundColor: "white" }}
          >
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{ height: "470px" }}
              />
            </Spin>
          </div>
        )}
        <Tabs type={"card"} defaultActiveKey={"chart1"}>
          <Tabs.TabPane
            key={"chart1"}
            tab={chartShareTitle ? `${chartShareTitle} - ${searchYear}년` : `지역별 무선국 점유율(%) - ${searchYear}년`}
          >
            <ChartPane
              data={chartShareData1}
              processor={() => chartShareData1}
              layoutProcessor={() =>
                setChartLayoutforShare(CHART1_LAYOUT_PROPS, {
                  title: chartShareTitle,
                  searchYear,
                  _gubun_code: gubun_code,
                  _admin,
                  prm_check,
                  prm_check2,
                  prm_check2_label,
                })
              }
              style={
                chartShareData1 && chartShareData1.length > 16
                  ? { height: chartShareData1.length * 30 }
                  : { height: 470 }
              }
            />
          </Tabs.TabPane>
        </Tabs>
      </div>
    ),
  });
}

const CHART1_LAYOUT_PROPS = {
  xtitle: "점유율(%)",
  ytitle: "지역명",
  chartType: "Multi Series Stacked Bar",
  layOutStyle: "Detail",
  masterName: "무선국 점유율",
  valueFixed: 5,
};

const CHART2_LAYOUT_PROPS = {
  xtitle: "지역명",
  ytitle: "무선국 수",
  chartType: "Multi Series Stacked",
  layOutStyle: "Detail",
  masterName: "무선국 수",
  valueFixed: 0,
};

const CHART3_LAYOUT_PROPS = {
  xtitle: "지역명",
  ytitle: "무선국 밀도(국수/㎢)",
  chartType: "Multi Series Stacked",
  layOutStyle: "Detail",
  masterName: "무선국 밀도",
  valueFixed: 5,
};

export default RMateChartFusionResource;
